import { createSlice } from "@reduxjs/toolkit";
import { REHYDRATE } from "redux-persist";

const getInitialState = () => {
  try {
    const persistedState = localStorage.getItem("persist:waste-facility-data");
    const token = localStorage.getItem("facility_access_token");
    if (persistedState) {
      const parsed = JSON.parse(persistedState);
      const authState = parsed;
      if (authState && token) {
        return {
          user: authState,
          token: token,
          isAuthenticated: true,
        };
      }
    }
  } catch (error) {
    console.error("Error loading persisted state:", error);
  }
  return {
    user: null,
    token: localStorage.getItem("facility_access_token") || "",
    isAuthenticated: localStorage.getItem("facility_access_token")
      ? true
      : false,
  };
};

const initialState = getInitialState();

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      const responseData = action.payload;

      state.user = responseData;
      state.token = responseData.token;
      state.isAuthenticated = true;

      //* Storing the user data in local storage
      localStorage.setItem("facility_access_token", responseData.token);
      localStorage.setItem(
        "persist:waste-facility-data",
        JSON.stringify(responseData)
      );
    },

    clearUser: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;

      localStorage.removeItem("facility_access_token");
      localStorage.removeItem("persist:waste-facility-data");
    },

    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(REHYDRATE, (state, action) => {
      if (action.payload && action.payload.auth) {
        return {
          ...state,
          ...action.payload.auth,
        };
      }
      return state;
    });
  },
});

export const selectUser = (state) => state.auth.user;
export const selectToken = (state) => state.auth.token;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;

export const { setUser, clearUser, updateUser } = authSlice.actions;
export default authSlice.reducer;
